import React from 'react';
import create from 'zustand';
import { TryOnMode, ZakekeTryOnExposedMethods } from '@zakeke/zakeke-configurator-react';

export const MOBILE_BREAKPOINT = 1024;

interface Store {
	isMobile: boolean;
	setIsMobile: (isMobile: boolean) => void;

	dialogs: { id: string; dialog: React.ReactElement }[];
	addDialog: (id: string, dialog: React.ReactElement) => void;
	removeDialog: (id: string) => void;

	tryOnRef?: React.RefObject<ZakekeTryOnExposedMethods>;
	setTryOnRef: (ref: React.RefObject<ZakekeTryOnExposedMethods>) => void;
	modeTryOn: TryOnMode;
	setTryOnMode: (modeTryOn: TryOnMode) => void;
	tryOnVisible: boolean;
	setTryOnVisible: (tryOnVisible: boolean) => void;
	deepARUrl: string;
	setDeepARUrl: (deepARUrl: string) => void;
	isLoading: boolean;
	setIsLoading: (isLoading: boolean) => void;

	aiStudioViewerContainerId: string | null;
	setAIStudioViewerContainerId: (containerId: string | null) => void;
}

const useStore = create<Store>((set) => ({
	isMobile: window.innerWidth <= MOBILE_BREAKPOINT,
	setIsMobile: (isMobile: boolean) => {
		set({
			isMobile
		});
	},

	dialogs: [],
	addDialog: (id: string, dialog: React.ReactElement) => {
		set((state) => ({
			dialogs: [...state.dialogs, { id, dialog }]
		}));
	},
	removeDialog: (id: string) => {
		set((state) => ({
			dialogs: state.dialogs.filter((dialog) => dialog.id !== id)
		}));
	},

	tryOnRef: undefined,
	setTryOnRef: (ref: React.RefObject<ZakekeTryOnExposedMethods>) => {
		set(() => ({
			tryOnRef: ref
		}));
	},

	modeTryOn: TryOnMode.TryOn,
	setTryOnMode: (modeTryOn: TryOnMode) => {
		set(() => ({
			modeTryOn
		}));
	},
	tryOnVisible: false,
	setTryOnVisible: (tryOnVisible: boolean) => {
		set(() => ({
			tryOnVisible
		}));
	},
	isLoading: false,
	setIsLoading: (isLoading: boolean) => {
		set({
			isLoading
		});
	},
	deepARUrl: '',
	setDeepARUrl: (deepARUrl: string) => {
		set(() => ({
			deepARUrl
		}));
	},

	aiStudioViewerContainerId: null,
	setAIStudioViewerContainerId: (containerId: string | null) => {
		set({
			aiStudioViewerContainerId: containerId
		});
	}
}));

export default useStore;
